import { css } from '@emotion/react'
import { Color, Spacing } from '@opallabs/gem'
import { modernWithFallback } from '@opallabs/lambda'

export const content = () =>
  css({
    color: Color.light['Text/Primary'],
    textAlign: 'start',

    '& > :first-child': {
      marginBlockStart: 0,
    },

    'p, h1, h2, h3, h4': {
      marginBlock: '4px',
      marginInline: '0',
    },

    maxBlockSize: '95px',
    ...modernWithFallback(
      [{ overflowBlock: 'auto' }, { overflowY: 'auto' }],
      'overflow-block: auto'
    ),

    '[data-type="mention"]': {
      backgroundColor: Color.light['Color/Primary/Primary-3'],
      borderRadius: Spacing.XS,
      color: Color.light['Text/Links'],
      padding: `${Spacing.XS / 2}px ${Spacing.XS}px`,
    },
  })

export const buttonGroup = css({
  display: 'flex',
  justifyContent: 'flex-start',
  alignItems: 'center',
  flexDirection: 'row',
  gap: Spacing.XS,
})

export const button = css({
  color: Color.light['Icons/Secondary'],
})

export const footerActions = css({
  display: 'flex',
  justifyContent: 'space-between',
  alignItems: 'center',
  paddingBlockStart: Spacing.S,
  opacity: 1,
  blockSize: '32px',
})
